import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getCommunities } from '../lib/api-client';
import { useAuth } from '../context/AuthContext';
import CommunityList from '../components/desktop/CommunityList';
import LoadingScreen from '../components/desktop/LoadingScreen';

export default function Communities() {
  const [searchParams] = useSearchParams();
  const { user: authUser, loading: authLoading } = useAuth();
  const [loading, setLoading] = useState(true);
  const [communities, setCommunities] = useState<any[]>([]);
  const [communityPosts, setCommunityPosts] = useState<any[]>([]);

  const sort = searchParams.get('sort') || 'popular';

  // Transform authUser to expected format
  const currentUser = authUser ? {
    id: authUser.id.toString(),
    username: authUser.username,
    displayName: authUser.displayName || authUser.username,
    avatar: authUser.profilePicture || undefined,
    isSiteAdmin: authUser.isSiteAdmin || false,
    isSiteModerator: authUser.isSiteModerator || false,
    isSuperAdmin: authUser.isSuperAdmin || false
  } : null;

  useEffect(() => {
    if (!authLoading) {
      loadData();
    }
  }, [sort, authLoading]);

  async function loadData() {
    setLoading(true);
    try {

      // Load communities
      const communityData = await getCommunities();

      // Client-side sorting based on query param
      let sorted = [...communityData];
      switch (sort) {
        case 'newest':
          sorted.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
          break;
        case 'oldest':
          sorted.sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
          break;
        case 'popular':
        default:
          sorted.sort((a, b) => b.memberCount - a.memberCount);
          break;
      }

      setCommunities(sorted);
      setCommunityPosts([]);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <CommunityList
      communities={communities}
      currentUser={currentUser}
      initialPosts={communityPosts}
      isAuthenticated={!!authUser}
    />
  );
}
